<!-- <div class="page-contents" style="background: #E5E5E5; height:100%;overflow-x: auto;"> -->
<div class="page-contents">
  <div class="blockContainer flexbox-style-one" id='levelOne'>
    <div class="breadcrumbWrapper">
      <app-breadcrumb [inputbreadcrumbs]="breadcrumbs"></app-breadcrumb>
    </div>
    <div class="levelOne-full-container" id='levelOne'>
      <div class="entry-container">
        <app-kbtemplate></app-kbtemplate>
      </div>
    </div>
  </div>
</div>
